<template>
    <div>
        <audio ref="newOrderSound">
            <source src="../../assets/mp3/new_order.mp3" type="audio/mpeg">
        </audio>
        <CCard v-if="useFilter" class="p-1">
            <CRow>
                <CCol cols="12" col="6" sm="6" xl="3" class="d-flex align-items-center custom-order-2 order-sm-2 order-xl-1 mb-sm-2 mb-xl-0">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="showFilters"
                        class="ml-2" />
                    <span class="ml-2">Фильтры</span>
                </CCol>
                <CCol cols="12" col="12" sm="12" xl="5" class="custom-order-1 order-sm-1 order-xl-2 mb-3 mb-sm-0">
                    <CRow>
                        <CCol v-if="useSorter" cols="12" col="6" sm="8" xl="10">
                            <CSelect
                                v-if="useSorter"
                                class="mb-xl-0 ml-sm-2"
                                placeholder="Сортировка..."
                                :value.sync="sorter"
                                :options="sorterOptions"
                                :change="setSorter()" />
                        </CCol>
                        <CCol v-if="useSorter" cols="12" col="6" sm="4" xl="2" class="text-right">
                            <CButton
                                v-if="useSorter"
                                class="mr-2"
                                color="secondary"
                                @click="resetSorter">Сбросить</CButton>
                        </CCol>
                    </CRow>
                </CCol>
                <CCol cols="12" col="6" sm="6" xl="4" class="text-right custom-order-3 order-sm-3 order-xl-3 mb-sm-2 mb-xl-0">
                    <CButton
                        color="info"
                        class="mr-2"
                        @click="openSettingsModal">Выбрать колонки</CButton>
                </CCol>
            </CRow>
            <CRow v-if="showFilters" class="mb-3 mt-3 pl-1">
                <CCol cols="12" md="2"> С: </CCol>
                <CCol cols="12" md="4">
                    <DatePicker
                        v-model="filter.from"
                        :language="datepicker.lang"
                        :format="datepicker.format"
                        input-class="custom-datepicker"
                        placeholder="Выберите дату..."
                    />
                </CCol>
                <CCol cols="12" md="2"> По: </CCol>
                <CCol cols="12" md="4">
                    <DatePicker
                        v-model="filter.to"
                        :language="datepicker.lang"
                        :format="datepicker.format"
                        :change="$emit('set-filter', filter)"
                        input-class="custom-datepicker"
                        placeholder="Выберите дату..."
                    />
                </CCol>
            </CRow>
            <CRow v-if="showFilters">
                <CCol cols="12" md="6">
                    <CButton
                        v-if="useFilter"
                        color="secondary"
                        @click="resetFilters">Сбросить</CButton>
                </CCol>
            </CRow>
        </CCard>
        <span class="ml-2">Всего: <strong>{{ total }}</strong></span>
        <!-- Add class 'custom-table' to make table adaptive for height -->
        <CDataTable
            :class="`orders ${useFilter ? '' : 'large'}`"
            :column-filter="useSearch"
            hover
            :items="list"
            :fields="fields"
        >
            <!-- ID -->
            <template #id-filter>
                <CInput
                    v-model="searchFilters.id"
                    class="mb-0 small__input"
                    type="text"
                />
            </template>
            <template #id="data">
                <td>
                    <CLink :to="`orders/${data.item.id}`">
                        {{ data.item.description ? data.item.description : data.item.invoice_id }}
                    </CLink>
                </td>
            </template>
            <!-- Создан -->
            <template #created_at-filter>
                <CInput
                    v-model="searchFilters.created_at"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #created_at="data">
                <td>{{ getCreatedAt(data.item.created_at) }}</td>
            </template>
            <template #partner="data">
                <td>{{ data.item.partner && data.item.partner.title ? data.item.partner.title : '' }}</td>
            </template>
            <!-- Изменен -->
            <template #updated_at-filter>
                <CInput
                    v-model="searchFilters.updated_at"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #updated_at="data">
                <td>{{ getUpdatedAt(data.item.updated_at) }}</td>
            </template>
            <!-- Услуги VIP MIRCITY -->
            <template #delivery_price-filter>
                <CInput
                    v-model="searchFilters.delivery_price"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #delivery_price="data">
                <td>{{ data.item.delivery_price }}</td>
            </template>
            <!-- Услуги партнера -->
            <template #price-filter>
                <CInput
                    v-model="searchFilters.price"
                    class="mb-0 small__input"
                    type="text"
                />
            </template>
            <template #price="data">
                <td>{{ data.item.price }}</td>
            </template>
            <template #payments="data">
                <td><a href="#" @click="showPayments(data.item)">Показать</a></td>
            </template>
        </CDataTable>

        <CModal
            class="vip-orders-modal"
            :show.sync="paymentsModal">
            <template>
                <div slot="header">Оплаты</div>
                <div slot="body-wrapper" class="modal-body">
                    <table class="table">
                        <tr>
                            <th width="100">Дата</th>
                            <th>Сумма</th>
                            <th>Транзакция</th>
                            <th width="120">Чек</th>
                            <th width="160"></th>
                        </tr>
                        <tr v-for="item in payments" :key="`payment-${item.id}`">
                            <td>{{ getCreatedAt(item.created_at) }}</td>
                            <td>{{ item.amount }}</td>
                            <td>{{ item.transaction_id }}</td>
                            <td><CInput v-model="item.receipt_id" placeholder="Id чека"></CInput></td>
                            <td><CButton color="primary" @click="setReceipt(item.id, item.receipt_id)">Проверить чек</CButton></td>
                        </tr>
                    </table>
                </div>
                <div slot="footer">
                    <CButton color="error" @click="paymentsModal = false">Закрыть</CButton>
                </div>
            </template>
        </CModal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapState } from 'vuex';
    import store from '@/store';
    import moment from 'moment';
    import _ from 'lodash';
    import countdown from 'countdown';
    import Multiselect from 'vue-multiselect';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    require('moment-countdown');

    import { ORDER_STATUS, DELIVERY_TYPE, ORDER_TYPE, PASS_TYPE } from '../../utils/order';
    const {
        formatDateShort,
        formatTimeShort,
    } = require('../../utils/views');

    export default {
        components: {
            Multiselect,
            DatePicker
        },

        props: {
            list: {
                type: Array,
                default: () => [],
            },
            total: {
                type: Number,
                default: 0,
            },
            orderType: {
                type: String,
                default: 'all',
            },
            useFilter: {
                type: Boolean,
                default: false,
            },
            useSorter: {
                type: Boolean,
                default: false,
            },
            useSearch: {
                type: Boolean,
                default: false,
            },
            completed: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                fieldsAll: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'created_at', label: 'Создан' },
                    { key: 'updated_at', label: 'Обновлен' },
                    { key: 'partner', label: 'Партнер' },
                    { key: 'delivery_price', label: 'Услуги VIP MIRCITY', admin_only: true },
                    { key: 'price', label: 'Услуги партнера' },
                    { key: 'payments', label: 'Оплаты' },
                ],
                // Fields
                fieldsSettings: {},
                settingsModal: false,
                // Sorter
                sorter: localStorage.getItem('orders-table-sorter') || '',
                sorterOptions: [
                    { value: '', label: 'Сортировка...' },
                    // { value: "id-asc", label: "ID: по возрастанию" },
                    // { value: "id-desc", label: "ID: по убыванию" },
                    { value: 'created_at-asc', label: 'Создан: по возрастанию' },
                    { value: 'created_at-desc', label: 'Создан: по убыванию' },
                    { value: "updated_at-asc", label: "Обновлен: по возрастанию" },
                    { value: "updated_at-desc", label: "Обновлен: по убыванию" },
                    // { value: 'delivery_time-asc', label: 'Доставка: по возрастанию' },
                    // { value: 'delivery_time-desc', label: 'Доставка: по убыванию' },
                    { value: "price-asc", label: "Услуги партнера: по возрастанию" },
                    { value: "price-desc", label: "Услуги партнера: по убыванию" },
                    // { value: 'status-asc', label: 'Статус: по возрастанию' },
                    // { value: 'status-desc', label: 'Статус: по убыванию' },
                ],
                // Filters
                showFilters: false,
                filter: {
                    from: null,
                    to: null,
                },
                filterOptions: {
                    from: null,
                    to: null,
                },
                searchFilters: {
                    id: '',
                    comment: '',
                    customer: '',
                    price: '',
                },
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                PASS_TYPE,
                DELIVERY_TYPE,
                lastOrderId: null,
                soundsOnModal: false,
                newOrderModal: false,

                paymentsModal: false,
                payments: []
            };
        },

        computed: {
            fields() {
                const result = [];
                for (const item of this.fieldsAll) {
                    if(this.adminOnly || !item.admin_only) {
                        if (item.key === 'type') {
                            if (this.orderType === 'all') {
                                if (this.fieldsSettings[item.key]) {
                                    result.push(item);
                                }
                            }
                        } else {
                            if (this.fieldsSettings[item.key]) {
                                result.push(item);
                            }
                        }
                    }
                }
                return result;
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        },

        watch: {
            searchFilters:{
                deep: true,
                handler() {
                    if (this.useSearch) {
                        const debounceFunc = _.debounce( () => {
                            const search = { ...this.searchFilters };
                            if (search) {
                                for (const key in search) {
                                    if (!search[key]) {
                                        delete search[key];
                                    }
                                }
                            }
                            if(search && search.customer && search.customer.length >= 3) {
                                this.$emit('set-search', search);
                            } else if (search.customer && search.customer.length < 3) {
                                search.customer = '';
                            } else {
                                this.$emit('set-search', search);
                            }
                        }, 1000)

                        debounceFunc();
                    }
                }
            },
            datepicker() {
                this.filter.from = this.datepicker.dateFrom;
                this.filter.to = this.datepicker.dateTo;
            },
            list:{
                deep: true,
                handler() {
                    console.log('this.list', this.list);
                }
            },
        },

        async created() {
            this.fieldsSettings = this.getFildsSettings();
            this.filterOptions = await this.getFilterOptions();
        },
        mounted() {
            store.dispatch('settings/fetch');
        },

        methods: {
            getCreatedAt(created_at) {
                return formatDateShort(moment(created_at).toDate());
            },
            getUpdatedAt(update_at) {
                return formatDateShort(moment(update_at).toDate());
            },
            // Fields settings
            getFildsSettings() {
                var fieldsSettings = JSON.parse(
                    localStorage.getItem('orders-table-settings')
                );
                if (!fieldsSettings) {
                    fieldsSettings = this.getDefaultFieldsSettings();
                }
                return fieldsSettings;
            },
            getDefaultFieldsSettings() {
                const result = {};
                for (const item of this.fieldsAll) {
                    result[item.key] = true;
                }
                return result;
            },
            setFieldsSettings(fieldsSettings) {
                localStorage.setItem(
                    'orders-table-settings',
                    JSON.stringify(fieldsSettings)
                );
            },
            openSettingsModal() {
                this.settingsModal = true;
            },
            closeSettingsModal() {
                this.setFieldsSettings(this.fieldsSettings);
                this.settingsModal = false;
                this.$forceUpdate();
            },
            resetSorter() {
                this.sorter = '';
                localStorage.setItem(
                    'orders-table-sorter',
                    this.sorter
                );
            },
            setSorter() {
                localStorage.setItem(
                    'orders-table-sorter',
                    this.sorter
                );
                this.$emit('set-sorter', this.sorter);
            },
            // Filters
            async getFilterOptions() {
                return {
                    from: this,
                    to: null,
                };
            },
            resetFilters() {
                this.filter = {
                    from: null,
                    to: null,
                };
            },
            cutComment(comment) {
                return `${comment.slice(0, 15)}...`;
            },
            cutDeliveryAddress(address) {
                return `${address.slice(0, 15)}...`;
            },
            showPayments(order) {
                this.payments = order.payments;
                this.paymentsModal = true;
                return false;
            },
            async setReceipt(payment_id, receipt_id) {
                await this.axios.put(`/vip-partners/payments`, { payment_id, receipt_id });
                this.$emit('fetch');
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.custom-table .position-relative.table-responsive {
    max-height: calc(100vh - 407px);
}
.custom-table.large .position-relative.table-responsive {
    max-height: calc(100vh - 337px);
}

.custom-table table thead th {
    position: sticky;
    box-shadow: 0 0 0 rgba( 0, 0, 0, .3);
    top: -1px;
    background: #fff;
}
.orders .small__input input {
    padding: 0;
}
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
}

.orders table thead th {
    padding: 2px 4px;
    font-size: 11px;
}
.vip-orders-modal .modal-dialog {
    max-width: 650px;
}
</style>

<style scoped>
.dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    vertical-align: middle;

    vertical-align: middle;

    background: red;

    border-radius: 50%;
}
.dot.seen {
    background: #23d923;
}
.warning-cell {
    background: red;
    border-radius: 10px;

    color: #fff;
    font-weight: bold !important;
}
.status-cell span {
    display: block;
}
.orders table td,
.orders table th {
    white-space: nowrap;
    padding: 0.1rem;
}

@media (max-width: 576px) {
    .custom-order-1 {
        order: 1;
    }
    .custom-order-2 {
        order: 2;
    }
    .custom-order-3 {
        order: 3;
    }
}
.pass__info {
    display: inline-block;
    width: 20px;
    height: 12px;

    border: 2px solid;
    border-radius: 3px;
}
.not__passed {
    background: red;
    border-color: red;
}
.passed {
    background: #68CE85;
    border-color: #68CE85;
}
.not__need {
    background: transparent;
    border-color: #68CE85;
}
.without__delivery {
    background: transparent;
    border-color: #ff7b49;
}
.first__order {
    font-size: 12px;
    color: #2eb85c;
}
</style>
